import { applyMiddleware, createStore } from "redux";
import { persistReducer, persistStore } from "redux-persist";

import { composeWithDevTools } from "@redux-devtools/extension";
import rootReducer from "./rootReducer";
import storage from "redux-persist/lib/storage";
import thunk from "redux-thunk";

export type StateType = ReturnType<typeof store.getState>;

/**
 * Persist config
 */
const persistConfig = {
  key: "root",
  storage,
  blacklist: ["auth", "manualData", "pcpSelection", "fetchData"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = createStore(
  persistedReducer,
  composeWithDevTools({
    serialize: {
      replacer: (_key: string, value: unknown) => {
        if (value instanceof DOMException) {
          return { message: value.message, name: value.name };
        }
        return value;
      },
    },
  })(applyMiddleware(thunk))
);

export const persistor = persistStore(store);

// persistor.purge()
